import type { User } from "../services/authService";
import { UserRole } from "../types/auth";

export const isAdministrator = (user: User | null | undefined) =>
  user?.user_type === UserRole.ADMINISTRATOR || user?.role === "administrator";

export const isPropertyManager = (user: User | null | undefined) =>
  user?.user_type === UserRole.PROPERTY_MANAGER || user?.role === "property_manager";

export const canManagePropertyManagers = (user: User | null | undefined) =>
  isAdministrator(user) &&
  (!user?.capabilities || user.capabilities.includes("property_managers.manage"));

export const canViewReports = (user: User | null | undefined) =>
  isAdministrator(user) ||
  isPropertyManager(user) ||
  user?.capabilities?.includes("reports.view") === true;
